var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.touchDevice)?_c('div',{directives:[{name:"mouse-pointer",rawName:"v-mouse-pointer"},{name:"mouse-hover",rawName:"v-mouse-hover"}],staticClass:"mouse-custom",class:{
    'mouse-custom--hover': _vm.isHover,
    'mouse-custom--hover--big': _vm.isHoverBig
  }},[_c('div')]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }